import "core-js/stable";
import "regenerator-runtime/runtime";

var componentRequireContext = require.context("contexts/aql_calculator", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
